import once from 'lodash-es/once';

import { httpPost } from '@jane/bloom/utils/http/post.client';

type GoogleGeolocation = {
  accuracy: number;
  location: {
    lat: number;
    lng: number;
  };
};

export const getApproximateLocation = once(
  async (googlePlacesApiKey: string): Promise<GoogleGeolocation> => {
    try {
      return await httpPost(
        `https://www.googleapis.com/geolocation/v1/geolocate?key=${googlePlacesApiKey}`
      );
    } catch {
      return {
        accuracy: 0,
        location: {
          lat: 0,
          lng: 0,
        },
      };
    }
  }
);
